import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled from 'styled-components';
import { adjustContentVisibility, Section } from '../Content';
import type { DefaultSectionProps } from '../DefaultSectionProps';
import { TrustBullet } from './components';
import type { TrustBulletItemProps } from './types';

const TrustContent = styled.ul`
  display: flex;
  align-items: flex-start;
  gap: 30px;
  justify-content: center;
  width: min(100%, 1020px);

  ${MEDIA_QUERIES.tabletAndDesktop`
    flex-direction: row;
  `}

  ${MEDIA_QUERIES.mobile`
    flex-direction: column;
  `}
`;

const StyledSection = styled(Section)`
  ${adjustContentVisibility}
`;

export enum BulletsLayoutValue {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export interface TrustProps extends DefaultSectionProps {
  readonly bullets: TrustBulletItemProps[];
  readonly bulletsLayout?: `${BulletsLayoutValue}`;
}

export const Trust: React.FC<TrustProps> = ({ bullets, bulletsLayout = 'vertical', ...sectionProps }) => {
  return (
    <StyledSection {...sectionProps} py={[40, 70]} px="20px">
      <TrustContent>
        {bullets.map(bullet => (
          <TrustBullet bullet={bullet} bulletsLayout={bulletsLayout} key={bullet.name} />
        ))}
      </TrustContent>
    </StyledSection>
  );
};
